























import {CommonMixin} from "@/shared/services/mixin";
import {Component} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import PLReTransportSearch
  from "@/modules/pickinglistretransport/shared/component/PickingListReTransportSearch-v2/index.vue";
import {PickingListReTransportStore} from "@/modules/pickinglistretransport/store";
import {PickingListReTransportParams} from "@/modules/pickinglistretransport/params";
import PLReTransportTable
  from "@/modules/pickinglistretransport/shared/component/PickingListReTransportTable/index.vue";
import {getPublicPath} from "@/shared/services/helper/utils";
import PLReTransportDetail
  from "@/modules/pickinglistretransport/shared/component/PickingListReTransportDetail/index.vue";
import PLReTransportPrint
  from "@/modules/pickinglistretransport/shared/component/PickingListReTransportPrint/index.vue";

@Component({
  name: "StockOutReTransport",
  components: {PLReTransportPrint, PLReTransportDetail, PLReTransportTable, PLReTransportSearch}
})
export default class extends mixins(CommonMixin) {
  visible = false;
  id = null;
  
  printObj = {
    id: "picking-list-re-transport-print",
    popTitle: 'Logistic',
    extraCss: `${getPublicPath()}assets/css/print.css`,
  };
  
  created() {
    PickingListReTransportStore.updatePickingListReTransportParams({
      ...new PickingListReTransportParams()
    });
    PickingListReTransportStore.listPickingListReTransport(PickingListReTransportStore.params)
  }
  
  get pickingListReTransports() {
    return PickingListReTransportStore.ids.map((id: number) => PickingListReTransportStore.data[id])
  }
  
  onChangePage(pagination) {
    PickingListReTransportStore.listPickingListReTransport({
      ...PickingListReTransportStore.params,
      page: pagination.current,
      limit: pagination.pageSize
    })
  }
  
  async seeDetail(id: number) {
    if (isNaN(id)) return;
    this.id = id as any;
    await PickingListReTransportStore.listBillLadingByPickingListReTransport(this.id);
    this.visible = true;
  }
  
  createReTransport() {
    this.$router.push({name: "createReTransport"})
  }
  
  async deletePickingListReTransport(id: number) {
    if (isNaN(id)) return;
    try {
      await PickingListReTransportStore.deletePickingListReTransport(id);
      this.$message.success("Xóa bảng kê thành công");
    } catch (e) {
      this.$message.error(e?.response?.data?.message || 'Xóa bảng kê thất bại');
    }
  }
}
